define([
    'jquery',
    'lodash/object/assign',
    'lodash/function/bindAll'
], function ($, assign, bindAll) {
    'use strict';

    var BehindTheScenesPage = function (options) {
        assign(this.options, options);

        this.initialize();

    };

    assign(BehindTheScenesPage.prototype, {
        options: {},
        leftOpen: false,
        rightOpen: false,
        initialize: function () {
            bindAll(this);

            this.$el = $('body');
            this.checkDevice();

            $('.btn-prev-text span').animate({
                width: 29
            }, 100);
            $('.btn-next-post').animate({
                width: 29
            }, 100);
        },
        hoverPrevNav: function () {
            if (this.leftOpen === false) {
                if (this.leftOpen === false) {
                $('.btn-prev-post').animate({
                    width: 125
                }, 100);
                this.leftOpen = true;
            }
            }
        },
        unHoverPrevTextNav: function () {
            if (this.leftOpen) {
                $('.btn-prev-post').animate({
                    width: 29
                }, 100);
                this.leftOpen = true;
            }
            this.leftOpen = false;

        },
        hoverNextNav: function () {
            if (this.rightOpen === false) {
                $('.btn-next-post').animate({
                    width: 105
                }, 100);
                this.rightOpen = true;
            }
        },
        unHoverNextTextNav: function () {
            if (this.rightOpen) {
                $('.btn-next-post').animate({
                    width: 29
                }, 100);
                this.rightOpen = true;
            }
            this.rightOpen = false;
        },
        checkDevice: function () {
            if ($('.js').hasClass('touch') === false) {
                this.$el.on('mouseenter', '#left', this.hoverPrevNav);
                this.$el.on('mouseleave', '#left', this.unHoverPrevTextNav);
                this.$el.on('mouseenter', '#right', this.hoverNextNav);
                this.$el.on('mouseleave', '#right', this.unHoverNextTextNav);
            }
        }
    });

    return BehindTheScenesPage;
});



/** WEBPACK FOOTER **
 ** ./js/view/BehindTheScenesPage.js
 **/